<template> 
    <div class="productIn">        
            <b-container>                 
                <b-row>
                    <b-col class="col-6">                                                    
                        <img src="" class="label" v-if="product.Special  === true ">
                        <div class="parentLoading">
                            <Loading :class="{loading1:true?loading1:false}"/>      
                            <hooper :itemsToShow=1 class="gallery" pagination="no">
                                <slide style="padding:0;" v-for="(gallery,index) in galleries" :key="index"><img :src="myBaseUrl+gallery.FilePath"/></slide>
                                <hooper-pagination slot="hooper-addons"></hooper-pagination>
                            </hooper> 
                        </div>                  
                    </b-col>
                    <b-col class="col-6">
                        <h1 style="color: #6a1b9a">{{product.Name}}</h1>                                
                        <div class="description">
                            <!-- <span>توضیحات:</span> -->
                            <p  v-html="product.HtmlMainFeatures"></p>
                        </div>
                        <ul>
                            <li class="parentPrice">
                                <div v-if="product.Status === 0 ">
                                    <div v-if="product.SpecialPrice  && product.SpecialPrice!==product.Price">
                                        <span class="red">{{product.Price|splitNumber}}<span>تومان</span></span>
                                        <span class="price">{{product.SpecialPrice|splitNumber}}<span>تومان</span></span>
                                    </div>
                                    <div v-else>
                                        <span class="price">{{product.Price|splitNumber}}<span>تومان</span></span>
                                    </div>
                                </div>
                                <div v-else>
                                    <span class="price">ناموجود</span>
                                </div>                              
                            </li>                            
                            <li v-if="product.PurchaseAmountLimit != null " class="min">حد اقل سفارش :  <span>{{product.PurchaseAmountLimit}} {{product.CountUnit.Symbol}}</span></li>
                        </ul>                        
                        <div>
                            <b-button v-b-modal.modal-1 class="connectBtn">ارتباط با تولید کننده</b-button>
                            <b-modal id="modal-1">
                                <p class="my-4">{{product.Review}}</p>
                            </b-modal>
                        </div>                                            
                    </b-col>
                </b-row>

                <div>
                    <b-card no-body>
                        <b-tabs card>
                            <b-tab title="درباره محصول" active>
                                <b-card-text v-html="product.Desc"></b-card-text>
                            </b-tab>
                            <b-tab title=" مشخصات محصول">
                                <b-card-text v-for="feature in features" :key="feature.Id">
                                    <table>
                                        <tr>
                                            <th>{{feature.Feuture}}</th>
                                            <td>{{feature.StringValue}}</td>
                                        </tr>
                                    </table>
                                </b-card-text>
                            </b-tab>
                             <b-tab title="نظرات کاربران">
                                <b-card-text>                                   
                                    <div class="comments" v-for="comment in comments" :key='comment.Id'>
                                        <div class="commentItem">
                                            <strong>{{comment.Title}}</strong>
                                            <!-- <span>{{comment.DateTime|moment("fa,dddd, MMMM Do YYYY, h:mm:ss a")}}</span> -->
                                            <span>{{myMoment}}</span>
                                            <p>{{comment.Description}}</p>
                                        </div>
                                    </div>
                                     <!--form-->
                                      <!--title-->
                        <h2 class="title"><strong>ارسال نظر</strong></h2>
                        <form ref="form" @submit.stop.prevent="handleSubmit" class="taghaza" id="sendComment">
                                    <b-row>
                                            <!--********-->
                                            <b-col class="col-6">                           
                                            <b-form-group                             
                                                label="نام و نام خانوادگی"
                                                label-for="title"                                                                                                             
                                            >
                                            <b-form-input
                                            id="title"                     
                                            v-model="title"                    
                                            required
                                            type="text"                                                    
                                            ></b-form-input>
                                            <span class="invalid">{{titleState}}</span>                                                                         
                                            </b-form-group>
                                            </b-col>                                                                                 
                                            <!--********-->
                                            <b-col class="col-6">
                                                <b-form-group                             
                                                label="شماره تماس"
                                                label-for="mobile"                                                                           
                                                >
                                                <b-form-input
                                                    id="mobile"                     
                                                    v-model="mobile"                    
                                                    required                                
                                                    type="number"
                                                    class="dir-ltr"
                                                ></b-form-input>                      
                                                    <span class="invalid">{{mobileState}}</span>                      
                                                </b-form-group>
                                            </b-col>
                                            <!--********-->
                                            <b-col class="col-12">
                                                <b-form-group                             
                                                label="ایمیل"
                                                label-for="email"                                                                                                             
                                                >
                                                <b-form-input
                                                    id="email"                     
                                                    v-model="email"                    
                                                    required                                
                                                    type="email"
                                                    class="dir-ltr"                      
                                                ></b-form-input>                      
                                                    <span class="invalid">{{emailState}}</span>                      
                                                </b-form-group>
                                            </b-col>  
                                            <!--********-->
                                            <b-col class="col-12">
                                            <label label-for="text" >متن نظر</label>                         
                                                <b-form-textarea
                                                id="text"                               
                                                v-model="text"                           
                                                rows="1"
                                                max-rows="6"
                                                ></b-form-textarea>
                                                <span class="invalid">{{textState}}</span>   
                                            </b-col>                   
                                            <!--********-->
                                            <b-col class="col-12" style="position:relative">
                                                <div class="input-group">                           
                                                    <div id="recaptcha-main" class="g-recaptcha" data-sitekey="6Ldw7HIUAAAAAAW38OQmB98i3X070zN91Hm5J8fz"></div>                                                    
                                                    <button  type="button" class="send" @click="handleSubmit">ارسال نظر</button>
                                                </div>
                                                <span class="red">{{rcatch}}</span>
                                            </b-col>
                                        </b-row>                                                                                                                                                 
                                    </form> 
                                    <span class="red">{{result}}</span>
                                    <div class="resultForm" :class="{open:true?open:flase}">
                                        <span class="true" v-if="resultForm == true">درخواست شما ثبت شد<i data-v-27f46840="" class="mdi mdi-close" @click="closeResultForm"></i></span>
                                        <span class="false" v-else>درخواست شما ثبت نشد<i data-v-27f46840="" class="mdi mdi-close"></i></span>
                                    </div>                                     
                                </b-card-text>
                            </b-tab>
                        </b-tabs>
                    </b-card>
                </div>
                <!--Relate-->                                                                    
                <div class="relate" :class="{hide:true?hide:false}">
                    <h1 class="title"><strong>محصولات مرتبط</strong></h1>
                    <div class="row-hooper parentLoading">
                        <Loading :class="{loading2:true?loading2:false}"/> 
                        <hooper :settings="hooperSettings" class="myCarousel">                            
                            <slide v-for="(relate,index) in relates" :key="index" v-if="relate.Id != product.Id">                        
                                <app-product :product="relate"></app-product>                                                                  
                            </slide>
                        </hooper>                      
                    </div>
                </div>                                         
            </b-container>
    </div>
</template>

<script>
import {
  Hooper,
  Slide,
  Pagination as HooperPagination
  } from 'hooper';
import Product from   './Product'
import axios from 'axios'
import Loading from '../Loading'

export default {
    data(){
        return{
            productId:this.$route.params.Pid,
            hooperSettings: {
                itemsToShow: 3,                   
                breakpoints:{
                    320: {            
                        itemsToShow: 3,
                        // centerMode:true                        
                    },                    
                    768: {            
                        itemsToShow: 3
                    },
                    992: {            
                        itemsToShow: 3
                    },
                    1080: {            
                        itemsToShow: 3
                    }
                 }
            },
            product:{} ,
            galleries:null,
            features:[],
            relates:null,
            comments:[],
            title: '',        
            mobile:'',
            email:'',     
            text:'',
            result:'',
            resultForm:false, 
            open:false,
            captchaCheck:false,
            rcatch:'',                           
            /************/
            titleState: null,              
            mobileState: null ,  
            emailState: null ,
            textState:null ,
            loading1:false,
            loading2:false,
            hide:false
        }
    },
    components: {           
        Hooper,
        Slide,
        HooperPagination,
        appProduct:Product,
        Loading
    },
    watch:{
        '$route'(to,from){
            this.productId = to.params.Pid
        },
        '$route.params': {
            handler(newValue) {
                const { productId } = newValue

                this.fetchData(productId)
            },
            immediate: true,
        }
    },        
    methods: { 
    myCallback(){
        var recaptchaInterval = setInterval(function(){
            if(document.getElementById('recaptcha-main')){
                 grecaptcha.render('recaptcha-main')
                 clearInterval(recaptchaInterval);
            }        
        },1000)
    },   
    closeResultForm(){
        this.open=false;
    },    
        /*start-states*/
    titleStates(){
      if (!this.title) {
        return this.titleState = "لطفا نام خود را وارد نمائید"
      }                                              
      else {
        return this.titleState = ""
      }
    },     
    mobileStates(){
      if (!this.mobile) {
        return this.mobileState = "لطفا شماره موبایل خود را وارد نمائید"
      }         
      else if(this.mobile.length < 11 || this.mobile.length > 12){
        return this.mobileState = "شماره موبایل باید 11 رقمی باشد"
      }                                
      else {
        return this.mobileState = ""
      }
    },
    emailStates(){
      if (!this.email){
        return this.emailState = "لطفا ایمیل خود را وارد نمائید"
      }
      else if(!this.validEmail(this.email)){
        return this.emailState = "ایمیل نا معتبر میباشد"
      }
      else{
        return this.emailState = "";            
      }
    },
    validEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    textStates(){
        if (!this.text){
            return this.textState = "لطفا نظر خود را وارد نمائید"
        }      
        else{
            return this.textState = "";            
        }
    },
    checkRecaptcha(){
        var recaptcha=new FormData(document.getElementById('sendComment'))
        if(!recaptcha.get('g-recaptcha-response').length){
            return this.rcatch = "اعتبار سنجی انجام نشده";
        }
        else{
            return this.rcatch ="";
        } 
    },
    /* end-states */ 
    handleSubmit() {
      this.titleStates();      
      this.emailStates();
      this.mobileStates();
      this.checkRecaptcha();
      this.textStates(); 
    var recaptcha=new FormData(document.getElementById('sendComment'))    
      if (this.titleState != "" ||  
          this.emailState != "" ||
          this.mobileState != "" ||
          this.rcatch != "" ||
          this.textState != ""            
         ) {
        return
      }
      else{
        const formData={            
          EntitiesName:'products',          
          Comments:{
            Type:'comments',
            Title:this.title,
        //   PhoneNumber:this.mobile,
            Email:this.email,
            Description:this.text,
            ProductsId:this.productId
            }
        }
         

        axios.post('/comments/AjaxCreateComment',formData,{headers:{'g-recaptcha-response':recaptcha.get('g-recaptcha-response')}})            
             .then((res)=>{                     
                 var rec=res.request.response;                             
                 console.log(rec) 
                if(rec === "0"){
                    this.result ="اعتبارسنجی انجام نشد"
                    console.log("0")
                }
                else if(rec === "2" || rec === "3"){
                    this.result =" خطایی در اعتبارسنجی رخ داده"
                    console.log("2")
                }
                else{                    
                    this.resultForm=true,
                    this.open=true 
                    this.result =""
                    console.log("1")
                }                                  
              })
              .catch((err)=>{
                console.log(err)
              }) 
          
      }
      },     
        fetchData(productId) {
           try{
               if(this.relates == null){
                    this.loading2 = true            
                }
                axios.get('/product/ProductDetailsDTO?id='+this.productId)
                .then((res)=>{               
                    this.product = res.data  
                    axios.get('/product/GetProductRelatedByCatId?catId='+this.product.ProductCategoryId)
                        .then((res)=>{               
                            this.relates = res.data                            
                            this.loading2 = false  
                            if(this.relates.length<2) return  this.hide=true              
                        })
                        .catch((err)=>{
                            console.log(err)
                        })                
                })
                .catch((err)=>{
                    console.log(err)
                })
                if(this.galleries == null){
                    this.loading1 = true            
                } 
                axios.get('/Gallery/GetGalleryByGalleryCategoryType?parentEntityId='+this.productId+'&entitiesName=products&galleryType=image')
                .then((res)=>{               
                    this.galleries = res.data 
                    this.loading1 = false                
                })
                .catch((err)=>{
                    console.log(err)
                }),
                axios.get('/product/GetProductFeatureValue?productId='+this.productId)
                .then((res)=>{               
                    this.features = res.data                
                })
                .catch((err)=>{
                    console.log(err)
                }) ,

                axios.get('/comments/GetCommentsByEntityId?parentEntityId='+this.productId+'&entityName=products')
                .then((res)=>{               
                    this.comments = res.data                                                                 
                })
                .catch((err)=>{
                    console.log(err)
                })                        
            }                
            catch(ex){console.log(ex)}
            }            
    },
    created(){
       this.myCallback();
    }   
}
</script>

<style scoped>
.hide{
    display: none;
}
.loading1,
.loading2{
  display: block;
}
.productIn{text-align: right;}
ul{padding: 0;}
h1{
    color: #424242;
    font-size: 17pt;
    font-weight:normal;
    display: block;
    margin-bottom: 25px;
    line-height: 1.5;
}
.description {
    margin-bottom: 15px;
}
.description span{
    display: block;
    margin-bottom: 5px;
}
.connectBtn {
    background: #4caf50;
    color: #fff;
    font-size: 13pt;
    display: block;
    padding: 13px 25px;
    border-radius: 25px;
    min-width: 300px;
    -webkit-box-shadow: 0px 10px 30px 0px rgba(33,33,33,0.09);
    -moz-box-shadow: 0px 10px 30px 0px rgba(33,33,33,0.09);
    box-shadow: 0px 10px 30px 0px rgba(33,33,33,0.09);
    border: 0;
}
.gallery{
    margin-bottom: 30px;
    -webkit-box-shadow: 0px 7px 20px 0px rgba(33,33,33,0.15);
    -moz-box-shadow: 0px 7px 20px 0px rgba(33,33,33,0.15);
    box-shadow: 0px 7px 20px 0px rgba(33,33,33,0.15);
    border-radius: 50px;
    overflow: hidden;
    direction: ltr;  
}
.gallery img{
    width: 100%;
    display: block;
}
.tabs{
    margin-bottom: 50px;
}
.label{
    display: block !important;
    position: absolute;
    right: 0;
    top: 8%;
    z-index: 1;    
}
.parentPrice .red{
    color: red;
    margin-left:15px;
    text-decoration: line-through; 
     display: inline-block;
    vertical-align: middle;
}
.price {
    color: #4caf50;
    font-size: 13pt;
    display: inline-block;
    vertical-align: middle;    
}
.price span,
.red span{
    margin-right: 5px;
}
.min{display: block;margin: 15px 0;}
/*******/
.comments{
    margin: 15px 0 50px;
}
.commentItem{
    background: #fff;
    -webkit-box-shadow: 0px 15px 22px 0px rgba(0,0,0,0.15);
    -moz-box-shadow: 0px 15px 22px 0px rgba(0,0,0,0.15);
    box-shadow: 0px 15px 22px 0px rgba(0,0,0,0.15);
    border-radius:15px;
    padding: 15px; 
    margin-bottom: 15px;
}
.commentItem:after,.comments:after
{
    content: '';
    clear: both;
    display: table;
}
.commentItem strong{
    color: #333333;
    width: 70%;
    float: right;
    font-weight: normal;
    font-size: 13pt;
}
.commentItem span{
    color: #333333;
    width: 30%;
    float: left;
    text-align: left;
    font-weight: normal;
}
.commentItem p{
    color: #333333;    
    text-align-last: center;
    margin-top: 10px;
    clear: both;
    width: 100%;
    float: right;
    font-size: 11pt;
    line-height: 1.8;
}
/*******/
.taghaza{
    text-align: right;
    margin: 20px 0;
    padding: 0;
}
.red {
    color: red;
    font-weight: bold;
    font-size: 10pt;
    display: block;
}
.clear-both{
  clear: both;
}
.taghaza .row >div{
    margin-bottom: 15px;
}
.form-control {
    border: 0;
    border-bottom: 1px solid #777777;
    border-radius: 15px;
    -webkit-box-shadow: none;
    box-shadow:none;    
}
label{
  color: #424242;
  font-size: 15pt;
  font-weight: normal;
}
.form-control{
  padding-top: 0;
  height: 30px; 
}
.form-control:focus{
  box-shadow: none; 
  border-bottom-color:#6a1b9a;  
} 
.dir-ltr{
  direction: ltr;
}
.send{
  clear: both;
  display: block;
  width: 200px;
  height: 55px;
  background: #4caf50;
  color: #fff;
  font-size: 15pt;
  margin: 11px 35px;
  border: 0;
  border-radius: 25px;  
}
.invalid-feedback ,
.invalid{ 
    color: #dc3545;
    font-size: 9pt;
}
.form-group{margin: 0;}

.resultForm{
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.3);
  top: 0;
  right: 0;
  z-index: 10;
  display: none;
}
.resultForm.open{display: block;}
.resultForm >span{
    position: fixed;
    z-index: 11;
    width: 200px;
    height: 40px;
    padding: 12px 0;
    background: #fff;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    margin: auto;
    font-size: 9pt !important;
    text-align: center;
    border-radius: 25px;
}
.resultForm >span i{    
    position: absolute;
    right: 10px;
    color: #333;
    top: 7px;
    cursor: pointer;
    font-size: 14pt;
}
.resultForm .true{
  color: #3c763d;
  background-color: #dff0d8;
}
.resultForm .false{
  color: #a94442;
  background-color: #f2dede;
}
@media all and (max-width:992px) {
    h1 {    
        font-size: 15pt;
    }
    .description {
        margin-bottom: 15px;
        font-size: 10.5pt;
    }
    ul li ,.mainPrice{
        font-size: 10pt;
    }
    .price {    
        font-size: 15pt;
    }
    .connectBtn {     
        font-size: 12pt;      
        padding: 8px 15px;       
        min-width: 250px;
    }
    label {
        font-size: 13pt !important;
        margin: 0 !important;
  }
}
@media all and (max-width:767px) {    
    .gallery{
        width: 100%;
    } 
}
@media all and (max-width:576px) {   
    .gallery{
        width: 100%;              
    }
    p,p *{font-size: 11pt;}
    h1{font-size: 13pt;margin-bottom: 15px;}
    .price{font-size: 13pt;}
    .productIn .hooper-slide{padding: 0 5px;}
    .row-hooper{margin: 0 -5px;}
    .gallery {    
        border-radius: 20px;
    }
    .col-6:nth-child(2) {
    padding-right: 0;
}
h1 {
    font-size: 9pt;
    margin-bottom: 5px;
}
.description span {
    margin-bottom: 0;
    font-size: 8pt;
}
p, p *, p span {
    font-size: 8pt !important;
}
.price {
    font-size: 10pt;
}
.min {margin: 5px 0;    font-size: 8.5pt;}
.connectBtn {
    font-size: 9pt;
    padding: 5px 10px;
    min-width: 150px;
}
ul,p{margin: 0;}
.description{margin-bottom: 5px;}
label {
    font-size: 8.5pt;
    margin-right: 5px;
    display: block;
  }
  .col-6, .col-12 {
    margin-bottom: 15px;
  }
  .form-control {
    border-radius: 8px;
    font-size: 8.5pt;
    padding: 0 5px;
    height: 20px;
}
.row{margin: 0 -5px;}
.row>*{padding: 0 5px;}
.vpd-input-group label {
    left: 20px;
    top: -16px;
}
.send {   
    width: 150px;
    height: 35px;   
    font-size: 10pt;
    margin: 20px auto;
}

}
</style>


// WEBPACK FOOTER //
// src/components/products/SingleProduct.vue